/**
 * FreeSpins Class
 *
 * this module manages both freespins modes it inherits from spin functions
 *
 */

freespins = (function () {
  var _inFreeSpins = false;
  var _stopOffsets;
  var _currentMsgBox;
  var _msgBoxFinalPos = {};
  var _msgBoxStartPos = { x: 0, y: -500 };
  var _msgBoxIntroCallback;
  var _msgBoxOutroCallback;
  var _awardFreespinsTask;
  var _endFreespinsTask;

  var _initialDroppingFS = 0;
  var _bonusAnimsPlayed = false;

  var _freeSpinsMeter;
  let _gambleSpin;

  function initialise() {
    _gambleIntro = resourceManager.get('gambleIntroContainer:GambleIntro');
    _gambleSpin = resourceManager.get('gambleSpinContainer:GambleSpin');
    _freeSpinsMeter = resourceManager.get('freeSpinsMeter');
    _spinButton = resourceManager.get('buttonContainer:buttonBar:spinButton');

    const sunBurst = resourceManager.get('sunburst');
    sunBurst.alpha = 0.7;

    _sunBurstAnim = gsap.to(sunBurst, {
      paused: true,
      duration: 35,
      rotation: 2,
      yoyo: true,
      repeat: -1,
      ease: 'power2.inOut',
    });
  }

  /////////////////
  // button code //
  /////////////////

  function canEnableSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canShowSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canEnableSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  function canShowSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  // this just flips the layout between freeSpins and normal
  function freespinsMode(bool) {
    _inFreeSpins = bool;
  }

  function awardFreeSpinsComplete() {
    //slotMachine.selectReelMode("freespins");
    //musicManager.onFreespinsStart();
    _awardFreespinsTask.leave();
  }

  function onDecisionMade(task, resultCallback, gambleDecision) {
    if (gambleDecision === 'collect') {
      resultCallback({ response: 'collect' }, function () {
        task.leave();
      });
    } else {
      resultCallback({ response: 'gamble' }, function () {
        task.leave();
      });
    }
    gameController.cancelAutoplay();
  }

  function onFreespinsAwarded(task) {
    // Stop autoplay
    // autoplayManager.stopAutoplay();
    // resourceManager.getController("inputOverlord").setText("autoplayCancelButton", "");
    //gdk.cancelAutoplay();

    // animate the bonus symbols before bringing up the dialog
    let temp = task;
    temp.join();

    if (temp.data.buyABonus || _bonusAnimsPlayed) {
      showDialog(temp);
    } else {
      var bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;

      gameController.showBonusSymbols(false);

      for (var i = 0; i < reelManager.reels.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
            var animStrip = resourceManager.get(reelManager.reels[i].linkedAnimations[0].name);
            animStrip.showAnimation(j, bonusID);
          }
        }
      }
      soundManager.play('bonusWon');
      _bonusAnimsPlayed = true;

      timerManager.addTimer(1500, undefined, function () {
        // This timer is to allow the bonus sym anim to play, so don't change it :)
        for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
          var animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
          animStrip.hideAllAnimations();
        }
        gameController.showBonusSymbols(true);
        shootCanon();
        showDialog(temp);
      });
    }
  }

  function shootCanon() {
    const canon = resourceManager.get('slotContainer:canonContainer:canonSpineContainer:Canon');
    const canonBlast = resourceManager.get('slotContainer:canonContainer:canonBlastAnim');
    canon.play('animation', false, 0, undefined);
    canonBlast.gotoAndPlay(0);
  }

  function showDialog(task) {
    let temp = task;

    resourceManager.get('lanternMultiplier:lantern').resetMultiplier();

    // this.overlayBox = resourceManager.get("gameContainer:backingOverlay");
    // this.overlayBox.alpha = 0.0;
    // this.overlayBox.visible = false;
    //if (task.data.numScatters === 5){
    if (task.data.numScatters === 5 || !gdk.getPlatformAllowsGamble()) {
      // auto collect max bonus
      onDecisionMade(temp, temp.data.resultCallback, 'collect');
      return;
    }

    // mid gamble
    if (_gambleSpin.visible) {
      _gambleIntro.reactivate(
        task.data.freeSpinsAwarded,
        task.data.winChance,
        onDecisionMade.bind(this, temp, temp.data.resultCallback)
      );
    } else {
      //resourceManager.get("lanternMultiplier:lantern").closeDoor();

      // resets free spins index - base on scatters won
      // 3 scatters start at 0
      // 4 scatter - 1
      // 5 scatters - shouldn't gamble
      _gambleSpin.resetGambleSpin(task.data.numScatters - 3);

      let initialDelay = 0; //temp.data.buyABonus ? 0 : 1000;
      timerManager.addTimer(initialDelay, undefined, function () {
        _gambleIntro.start(
          task.data.freeSpinsAwarded,
          task.data.winChance,
          task.data.possibleValues,
          task.data.numScatters - 3,
          function () {
            setupFsScene(task.data.freeSpinsAwarded);
          },
          onDecisionMade.bind(this, temp, temp.data.resultCallback)
        );
      });
    }
  }

  function onFreespinsStart(task) {
    let temp = task;
    temp.join();

    _gambleSpin.visible = false;

    _sunBurstAnim.play();

    // this won't be playing if we've gone in with max free spins - so start here
    musicManager.onFreespinsIntro();

    _freeSpinsMeter.resetMeter();
    _freeSpinsMeter.addSpins(task.data.freeSpinsAwarded);

    _gambleIntro.doShowIntro(task.data.freeSpinsAwarded, function () {
      temp.leave();
      temp = undefined;
    });
  }

  function onFreespinsStartDead(task) {
    // if(autoplayManager.stopOnBonus){
    // 	gdk.autoplay.reset();
    // }

    _winnings = 0;

    // To get around sound being muted on Playzido when recovering in freespins, allow the player to enable sound again by moving mute button

    musicManager.onFreespinsStart();

    freespinsMode(true);
    hideSpinButton();
    startSpins();
  }

  function startSpins() {
    //musicManager.resetfreeSpinsLevel();

    startGame();

    gdk.getNextGameOutcome(function () {});
  }

  function startGame() {
    let fireFlies = resourceManager.get('slotContainer:fireFliesContainer:fireFliesAnim');
    fireFlies.visible = true;
    fireFlies.gotoAndPlay(0);
    gameController.hideCanon();
    gameController.resetWinnings();
    gameData.numPops = 0;

    gameController.onOrientationChange();

    freespins.spinTask = undefined;

    _freeSpinsMeter.useSpin();

    //		musicManager.resetfreeSpinsLevel();

    //slotMachine.infiniteSpin(game.stopDistances);

    //slotMachine.clearReels();
    //hideSpinButton();
    freespins.stateMachine.switchState('CLEAR_REELS');

    //freespins.stateMachine.switchState("REELS_SPINNING");
  }

  function hideSpinButton() {
    gameData.inputOverlord.setState('freespinsEnabled');
    //_spinButton.visible = false;
  }

  function onFreespinsAwardedEnd() {
    showSpinButton();
    gdk.getNextGameOutcome(function () {});
  }

  function showSpinButton() {
    _spinButton.visible = true;
  }

  function onMultiplierEvent(task) {
    // If we are at the top of the multiplier bar, ignore task
    if (task.data.nextMultiplier === -1 && task.data.currentStep > 1) {
      return;
    }

    freespins.MultiplierTask = task;
    //	task.join();

    //////	onStepUpComplete();
    //	_rightTotem.stepUp(onStepUpComplete);
  }

  function setupFsScene(numFs) {
    musicManager.onFreespinsIntro();
  }

  function onStepUpComplete() {
    freespins.MultiplierTask.leave();
    return;

    if (freespins.MultiplierTask.data.currentStep === 1 && freespins.MultiplierTask.data.currentMultiplier > 1) {
      // Increase multiplier
      var newNumSteps =
        freespins.MultiplierTask.data.nextMultiplier !== -1 ? freespins.MultiplierTask.data.totalSteps : 0;
      onIncreaseMultiplierComplete();
      //_rightTotem.increaseMultiplier(freespins.MultiplierTask.data.currentMultiplier, freespins.MultiplierTask.data.nextMultiplier, newNumSteps, onIncreaseMultiplierComplete);
    } else {
      freespins.MultiplierTask.leave();
    }
  }

  function onIncreaseMultiplierComplete() {
    freespins.MultiplierTask.leave();
    return;

    if (freespins.MultiplierTask.data.nextMultiplier !== -1) {
      //_rightTotem.stepUp( function() { freespins.MultiplierTask.leave(); } );
    } else {
      freespins.MultiplierTask.leave();
    }
  }

  function onFreespinsDataEvent(task) {
    _spinsRemaining = task.num;
    startGame();
    gdk.getNextGameOutcome(function () {});
  }

  function onGambleResultEvent(task) {
    let temp = task;
    temp.join();
    _gambleSpin.spinToResult(task.data.won, function () {
      temp.leave();
      temp = undefined;
    });
  }

  function onGambleResultEventDead(task) {
    // we've lost so restore reels container display and stop music
    // may need a delay to process visually
    if (!task.won) {
      _bonusAnimsPlayed = false;

      soundManager.stop('gambleLoop');

      musicManager.onFreespinsLostGambleEnd();
    }
  }

  function onFreespinsEndEvent(task) {
    // This is needed to ensure that the winnings are added before an RC popup can appear

    _endFreespinsTask = task;
    _endFreespinsTask.join();
    messageBox.setMessage('');

    musicManager.wasInFreeSpins = true;
    musicManager.onFreespinsEnd();

    resourceManager.getContainer('freeSpinsContainer').visible = false;

    _bonusAnimsPlayed = false;

    let freeSpinsWin = _endFreespinsTask.data.fsWinnings;

    _bigWin = resourceManager.get('bigWin');

    let isBigWin = _bigWin.willTriggerBigWin(freeSpinsWin);

    timerManager.addTimer(600, undefined, function () {
      if (isBigWin) {
        _bigWin.start(freeSpinsWin, doFreeSpinsOutroDialog.bind(this, freeSpinsWin));
      } else {
        doFreeSpinsOutroDialog(freeSpinsWin);
      }
    });
  }

  function doFreeSpinsOutroDialog(freeSpinsWin) {
    _sunBurstAnim.pause();

    _freeSpinsIntroOutro = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro');
    _freeSpinsIntroOutro.showOutro(freeSpinsWin, endFreespins);
  }

  function endFreespins() {
    resourceManager.getContainer('fsBackgroundContainer').visible = false;
    resourceManager.get('slotContainer:reelsBorderFS').visible = false;
    const fireFlies = resourceManager.get('slotContainer:fireFliesContainer:fireFliesAnim');
    fireFlies.visible = false;
    fireFlies.gotoAndStop(0);

    freespinsMode(false);

    gameData.inputOverlord.setState('enabled');
    freespins.stateMachine.switchState('READY_TO_START');
    gameController.showCanon();
    const encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
    if (encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled) {
      encoreButtonLB.handleStakeChange();
    } else {
      gameController.updateStake(gameController.inBuyABonus);
    }
    _endFreespinsTask.leave();
  }

  ////////////////////////////////////////////
  // define freespins Object to be returned //
  ////////////////////////////////////////////

  freespins = Object.create(spinFunctions);

  Object.defineProperties(freespins, {
    initialise: {
      value: initialise,
    },
    freespinsMode: {
      value: freespinsMode,
    },
    inFreespins: {
      get: function () {
        return _inFreeSpins;
      },
    },
    onFreespinsAwarded: {
      value: onFreespinsAwarded,
    },
    onFreespinsAwardedEnd: {
      value: onFreespinsAwardedEnd,
    },
    onFreespinsStart: {
      value: onFreespinsStart,
    },
    onFreespinsStartDead: {
      value: onFreespinsStartDead,
    },
    onFreespinsDataEvent: {
      value: onFreespinsDataEvent,
    },
    onFreespinsEndEvent: {
      value: onFreespinsEndEvent,
    },
    onGambleResultEvent: {
      value: onGambleResultEvent,
    },
    onGambleResultEventDead: {
      value: onGambleResultEventDead,
    },
    canEnableSpin: {
      value: canEnableSpin,
    },
    canShowSkip: {
      value: canShowSkip,
    },
    canEnableSkip: {
      value: canEnableSkip,
    },
    canShowSpin: {
      value: canShowSpin,
    },
    startGame: {
      value: startGame,
    },
  });

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(freespins);

  ///
  freespins.stateMachine.addState('WAITING_FOR_SERVER', function () {});

  ///
  freespins.stateMachine.addState('READY_TO_START', function () {});

  ///
  freespins.initialDropComplete = function (reelID) {
    --_initialDroppingFS;
  };

  freespins.areFreeSpinsActive = function () {
    return freespins._inFreeSpins;
  };

  ///
  freespins.stateMachine.addState('CLEAR_REELS', function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count

    if (freespins.phase.enter()) {
    }

    // ensure we have result data before proceeding - don't clear reels until this is set
    if (freespins.phase.hold()) {
      if (freespins.spinTask !== undefined) {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      slotMachine.clearReels();

      _initialDroppingFS = gameData.reels.length;
      gameController.resetSymbolCallbackFired();
    }

    if (freespins.phase.hold()) {
      if (_initialDroppingFS === 0) {
        let _positions = freespins.spinTask.data.resultPanel.reelList.map(function (reel, index) {
          return reel.symbols.map(function (curr) {
            return curr.value;
          });
        });

        // we need to have a random symbol as the first below which we can drop
        // off the symbol grid when new symbols all cascade in
        // NOTE:  Freespins can't retrigger so make sure no feature symbols are selected
        // Also wild symbols shouldn't be shown so limit to first 8
        let randomBelow = [];
        for (var i = 0; i < gameData.reels.length; i++) {
          randomBelow[i] = getRandom(8);
        }

        let _symbolsAbove = [[0], [0], [0], [0], [0]];
        let _symbolsBelow = [[randomBelow[0]], [randomBelow[1]], [randomBelow[2]], [randomBelow[3]], [randomBelow[4]]];

        // calculate whether we display landing symbols - this should be empty for free spins
        gameController.calcLandingAnims();

        slotMachine.dropInitialSymbols(_symbolsAbove, _positions, _symbolsBelow);
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      freespins.stateMachine.switchState('REELS_SPINNING');
    }
  });

  freespins.onSpinCompleteFS = function (reelID) {
    freespins.reelsSpinning[reelID] = false;
  };

  freespins.stateMachine.addState('REELS_SPINNING', function () {
    if (freespins.phase.enter()) {
      gameController._receivedResponse = true; // this allows slam stop
      freespins.reelsSpinning = [true, true, true, true, true];
    }

    // don't proceed until all reels have finished spinning
    if (freespins.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (var spinningIdx = 0; spinningIdx < freespins.reelsSpinning.length; spinningIdx++) {
        spinComplete = spinComplete && !freespins.reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        freespins.phase.step();
        gameController._receivedResponse = false;
      }
    }

    if (freespins.phase.once()) {
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');

      if (freespins.spinTask) {
        freespins.spinTask.leave();
      }
    }
  });

  freespins.stateMachine.addState('PAYWINS', function () {});

  freespins.stateMachine.addState('PAY_TO_WINNINGS', function () {
    if (freespins.phase.enter()) {
      gameData.winningsMeter.countUp(freespins.winsTask.data.totalLineWinnings, 1000);
      messageBox.hide();
    }
    if (freespins.phase.hold()) {
      if (!gameData.winningsMeter.Props.isCounting) {
        freespins.winsTask.leave();
      }
    }
  });

  function update(delta) {
    _delta = delta;
    this.stateMachine.update();
  }

  messageBus.subscribe('Game:MultiplierEvent', onMultiplierEvent);
  messageBus.subscribe('Game:FreeSpinsAwardEvent', onFreespinsAwarded);
  messageBus.subscribe('Game:FreeSpinsAwardEventDead', onFreespinsAwardedEnd);
  messageBus.subscribe('Game:FreeSpinsStartEvent', onFreespinsStart);
  messageBus.subscribe('Game:FreeSpinsStartEventDead', onFreespinsStartDead);
  messageBus.subscribe('Game:FreeSpinsDataEventDead', onFreespinsDataEvent);
  messageBus.subscribe('Game:FreeSpinsEndEvent', onFreespinsEndEvent);
  messageBus.subscribe('fire_gems:GambleResultEvent', onGambleResultEvent);
  messageBus.subscribe('fire_gems:GambleResultEventDead', onGambleResultEventDead);
  Reflex.addToUpdate(update.bind(freespins));

  return freespins;
})();
